<template>
  <div>
    PROFILES PAGE
  </div>
</template>

<script>
export default {
  name: 'GOOD3',
  props: {},
  data: () => ({
  }),
  mixins: {},
  computed: {},
  methods: {}
}
</script>

<style scoped>

</style>
